// src/configuration/ConfigurationLayout.js
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Description as DescriptionIcon,
  Business as BusinessIcon,
  Groups as GroupsIcon,
  AutoStories as AutoStoriesIcon,
  Link as LinkIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import WordTab from './WordTab';
import HiringRoomTab from './HiringRoomTab';
import CompanyContextTab from './CompanyContextTab';
import NarrativesTab from './NarrativesTab';
import CustomUrlTab from './CustomUrlTab';

const ConfigurationLayout = () => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
        {t('configuration.title')}
      </Typography>

      <Box sx={{ display: 'flex', gap: 3 }}>
        <Paper sx={{ width: 220, flexShrink: 0 }}>
          <Tabs
            orientation="vertical"
            value={currentTab}
            onChange={handleTabChange}
            sx={{ borderRight: 1, borderColor: 'divider' }}
          >
            <Tab
              icon={<DescriptionIcon />}
              iconPosition="start"
              label={t('configuration.tabs.word')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<BusinessIcon />}
              iconPosition="start"
              label={t('configuration.tabs.hiringRoom')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<GroupsIcon />}
              iconPosition="start"
              label={t('configuration.tabs.companyContext')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<AutoStoriesIcon />}
              iconPosition="start"
              label={t('configuration.tabs.narratives')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
            <Tab
              icon={<LinkIcon />}
              iconPosition="start"
              label={t('configuration.tabs.customUrl')}
              sx={{ justifyContent: 'flex-start', minHeight: 48 }}
            />
          </Tabs>
        </Paper>

        <Box sx={{ flexGrow: 1 }}>
          {currentTab === 0 && <WordTab />}
          {currentTab === 1 && <HiringRoomTab />}
          {currentTab === 2 && <CompanyContextTab />}
          {currentTab === 3 && <NarrativesTab />}
          {currentTab === 4 && <CustomUrlTab />}
        </Box>
      </Box>
    </Box>
  );
};

export default ConfigurationLayout;